// apitype
const apitypeList = [
  '2', '3', '4', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
// 通讯录
const contactsList = [
  {
    contactKey: 'contact',
    name: 'accountName',
    phone: 'accountPhone'
  },
  {
    contactKey: 'hfdrs',
    name: 'rwer',
    phone: 'weer'
  },
  {
    contactKey: 'weweree',
    name: 'werwe',
    phone: 'werer'
  },
  {
    contactKey: 'sdfw',
    name: 'wedrr',
    phone: 'werst'
  },
  {
    contactKey: 'fggghz',
    name: 'wwere',
    phone: 'fsdsf'
  },
  {
    contactKey: 'sqeqa',
    name: 'sdw',
    phone: 'fgf'
  },
  {
    contactKey: 'yteere',
    name: 'wer',
    phone: 'qws'
  },
  {
    contactKey: 'vders',
    name: 'sadd',
    phone: 'fees'
  },
  {
    contactKey: 'wethe',
    name: 'sdwes',
    phone: 'fgews'
  },
  {
    contactKey: 'wovji',
    name: 'mhf',
    phone: 'qivfd'
  },
  {
    contactKey: 'sdwew',
    name: 'sews',
    phone: 'wegs'
  },
  {
    contactKey: 'fswef',
    name: 'weer',
    phone: 'dsww'
  },
  {
    contactKey: 'lshjkf',
    name: 'fjahgd',
    phone: 'cbhduw'
  },
  {
    contactKey: 'rwersdfs',
    name: 'fwesd',
    phone: 'vcdf'
  },
  {
    contactKey: 'yuityuthg',
    name: 'dgerh',
    phone: 'jtuyjkt'
  },
  {
    contactKey: 'rutyrgdf',
    name: 'egdfhr',
    phone: 'dfgerw'
  },
  {
    contactKey: 'fdgseryhd',
    name: 'sdfsdfwe',
    phone: 'dfgerg'
  },
  {
    contactKey: 'ubhvjsd',
    name: 'ngbfhyw',
    phone: 'owuvbjdks'
  },
  {
    contactKey: 'mavrjd',
    name: 'rmobrlhrm',
    phone: 'yoaqf'
  },
  {
    contactKey: 'dyzjiaquo',
    name: 'dzjv',
    phone: 'yaupmneve'
  },
  {
    contactKey: 'kybufkmj',
    name: 'tpux',
    phone: 'ostromtnp'
  },
  {
    contactKey: 'jbvsaoz',
    name: 'etshevt',
    phone: 'bcljevqjc'
  },
  {
    contactKey: 'voxgg',
    name: 'kzqo',
    phone: 'gcrbhdvoh'
  },
  {
    contactKey: 'rygqybu',
    name: 'swrn',
    phone: 'metwtrr'
  },
  {
    contactKey: 'mkcfithi',
    name: 'fbqg',
    phone: 'nytocqrmb'
  },
  {
    contactKey: 'lmubzcjm',
    name: 'hkky',
    phone: 'qocobc'
  }

]
// 好评弹框方法
const scoreFuncNameList = [
  'tobagus',
  'uyeu',
  'ghhez',
  'uioweiaa',
  'fgdfgzs',
  'dwsd',
  'aknvhfjk',
  'gerdfz',
  'sdewes',
  'ebvhdjs',
  'erwer',
  'kutyjruy',
  'hfgmny',
  'fsdfwe',
  'ibvdhjsf',
  'amlmsgf',
  'gsrsboxijvnm',
  'suhi',
  'alls',
  'wpxxvykyze',
  'jhths',
  'ksmekrlgzow',
  'nxjrsqlqf'
]
export { contactsList, scoreFuncNameList, apitypeList }
